"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTranscriptionOutput = instanceOfTranscriptionOutput;
exports.TranscriptionOutputFromJSON = TranscriptionOutputFromJSON;
exports.TranscriptionOutputFromJSONTyped = TranscriptionOutputFromJSONTyped;
exports.TranscriptionOutputToJSON = TranscriptionOutputToJSON;
var Transcription_1 = require("./Transcription");
var Metadata_1 = require("./Metadata");
/**
 * Check if a given object implements the TranscriptionOutput interface.
 */
function instanceOfTranscriptionOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function TranscriptionOutputFromJSON(json) {
    return TranscriptionOutputFromJSONTyped(json, false);
}
function TranscriptionOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Transcription_1.TranscriptionFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function TranscriptionOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Transcription_1.TranscriptionToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
